import "./ServicesStyles.css"
import IMG_00 from '../Assets/IMG-25.jpg';
import IMG_01 from '../Assets/IMG-32.jpg';
import IMG_02 from '../Assets/IMG-28.jpg';
import IMG_03 from '../Assets/IMG-31.jpg';
import IMG_04 from '../Assets/IMG-45.jpg';
import IMG_05 from '../Assets/IMG-26.jpg';
import IMG_06 from '../Assets/IMG-44.jpg';
import IMG_07 from '../Assets/IMG-46.jpg';
import ServicesData from "./ServicesData";

const ServicesOffered = () =>{
    return(
        <div className="destinations">
            <h1>Insurance Solutions for Every Need</h1>
            <p>At Multishade Insurance, we offer a wide range of insurance products designed to meet the needs of individuals, families, and businesses. Our knowledgeable agents work 
                closely with you to understand your requirements and provide tailored solutions that offer maximum protection.</p>
            
           <ServicesData
           className="first-des"
           
           heading = "General Insurance"
           text=" Stay protected on the road with our comprehensive auto insurance policies.
            We offer flexible coverage options, including liability, collision, and comprehensive plans, 
           to keep you and your vehicle safe."

           img1={IMG_00}
           img2={IMG_01}

           
           />

        <ServicesData
        className="first-des-reverse"

           
           heading = "HealthCare Insurance"
           text="Protect your home and belongings with our customizable home insurance plans. 
           Whether you own a house, condo, or rent, we have policies to cover your property 
           against theft, damage, and natural disasters"

           img1={IMG_02}
           img2={IMG_03}

           
           />
           <br></br>
           <br></br>
           <ServicesData
           
           className="first-des"
           
           heading = "Pension"
           text="Safeguard your family's future with our health and life insurance options. 
           From basic health coverage to comprehensive life insurance policies, we help you 
           prepare for life's uncertainties"

           img1={IMG_04}
           img2={IMG_05}

           
           />

        <ServicesData
        className="first-des-reverse"

           
           heading = "Group Life"
           text=" Our business insurance solutions cater to small and large enterprises alike. We provide
            liability, property, and employee-related coverage to help you focus on growing your 
            business without worry."

           img1={IMG_06}
           img2={IMG_07}

           
           />
        </div>
    );
};

export default ServicesOffered;